import React from "react";
import { AllowedPrivacy, Experience, LineItemTemplateCode, PurchaseStatus } from "types";
import shallow from "zustand/shallow";
import { DemographicLineItem, useCreatePurchaseStore } from "../../stores/createPurchaseStore";
import { RadioInput } from "../Common/RadioInput";
import {
    eraseArrivalCacheForCreatePurchase,
    invalidateCacheForIndividualTimeslotRequests,
} from "./hooks/useArrivalTimeslots";

export const CreatePurchasePrivacy = () => {
    const { privacy, activeItemIndex, experience } = useCreatePurchaseStore(
        (state) => ({
            privacy: state.getActiveItem().privacy,
            activeItemIndex: state.activeItemIndex,
            experience: state.getActiveProduct<Experience>(),
        }),
        shallow,
    );

    const hasMultiplePrivacies = experience?.allowedPrivacies && experience.allowedPrivacies.length > 1;
    if (!hasMultiplePrivacies) {
        return null;
    }

    const activePrivacy = privacy ?? experience.allowedPrivacies?.[0];

    const handlePrivacyChange = (e: any) => {
        const privacy = e.target.value;
        const state = useCreatePurchaseStore.getState();
        if (state.purchaseId && state.purchase.status === PurchaseStatus.DRAFT) {
            eraseArrivalCacheForCreatePurchase(experience.id, privacy);
            invalidateCacheForIndividualTimeslotRequests(experience.id, privacy);
        }

        useCreatePurchaseStore.getState().actions.setPurchase((draft) => {
            draft.items[activeItemIndex].privacy = privacy;

            if (privacy === AllowedPrivacy.PUBLIC) {
                draft.items[activeItemIndex].lineItems = draft.items[activeItemIndex].lineItems.filter(
                    (lineItem) =>
                        !(
                            (lineItem as DemographicLineItem).code === LineItemTemplateCode.PER_OUTING_PRICE ||
                            (lineItem as DemographicLineItem).code === LineItemTemplateCode.PRIVATE_UPGRADE
                        ),
                );
            }
        });
    };

    return (
        <div>
            <div className="text-sm font-bold">Public or Private</div>

            <div className="flex flex-row items-center space-x-2">
                <RadioInput
                    checked={activePrivacy === AllowedPrivacy.PUBLIC}
                    name="privacy"
                    value={AllowedPrivacy.PUBLIC}
                    onChange={handlePrivacyChange}
                >
                    Public
                </RadioInput>

                <RadioInput
                    checked={activePrivacy === AllowedPrivacy.PRIVATE}
                    name="privacy"
                    value={AllowedPrivacy.PRIVATE}
                    onChange={handlePrivacyChange}
                >
                    Private
                </RadioInput>
            </div>
        </div>
    );
};
